import React, { useEffect, useState } from 'react';
import { Grid, Snackbar, SnackbarContent } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';

const Notifications = function ({ options = {} }) {
    const [severity, setSeverity] = useState('');
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [autoHide, setAutoHide] = useState(true);

    const { autoHide: optionsAutoHide, level, text } = options;

    useEffect(() => {
        if (text && text !== '') {
            setSeverity(level);
            setMessage(text);
            if (optionsAutoHide != null) {
                setAutoHide(optionsAutoHide);
            }
            setOpen(true);
        }
    }, [text, level, optionsAutoHide]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway' && autoHide) {
            return;
        }

        setOpen(false);
    };

    const classes = {
        error: {
            backgroundColor: '#f44336',
        },
        success: {
            backgroundColor: '#4caf50',
        },
        info: {
            backgroundColor: '#2196f3',
        },
        warning: {
            backgroundColor: '#ff9800',
        },
    };

    const renderIcon = (iconSeverity) => {
        switch (iconSeverity) {
            case 'error':
                return <ErrorOutlineIcon />;
            case 'warning':
                return <WarningIcon />;
            case 'info':
                return <InfoIcon />;
            case 'success':
                return <CheckCircleOutlineIcon />;
            default:
                return null;
        }
    };

    return (
        <div>
            <Snackbar
                id={`AlertNotification_${severity}`}
                open={open}
                autoHideDuration={autoHide ? 3000 : null}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                ContentProps={{
                    classes: {
                        root: classes.root,
                    },
                }}
            >
                <SnackbarContent
                    style={{ ...classes[severity], width: '500px' }}
                    message={
                        <Grid container direction="row" alignItems="center">
                            <Grid item style={{ paddingRight: '10px' }}>
                                {renderIcon(severity)}
                            </Grid>
                            <Grid item>{message}</Grid>
                        </Grid>
                    }
                />
            </Snackbar>
        </div>
    );
};

export { Notifications };
